import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import * as Yup from "yup";
import { getBranchCustomDetail } from '../../../../../Redux/action/Organisation/Branch/BranchAction';
import { adminMainUrl } from '../../../../../Config';
import axios from 'axios';
import Cookies from "js-cookie";
import { toast } from 'react-toastify';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Beatloader from '../../../../../Common/Loaders/Beatloader';
import BankDealerList from './CustomedeailTab/BankDealer/BankDealerList';

const CustomDetails = ({ branch_id, token, user_id, b64id }) => {
    const dispatch = useDispatch();

    const [showLoader, setShowLoader] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);

    const [activeTab, setActiveTab] = useState("bankdealer");
    const {
        //branch detail
        loadingBranchCustomDetail,
        BranchCustomDetailError,
        BranchCustomDetail,
    } = useSelector(state => state?.BranchReducer);




    const initialValues = {
        customer_id: "",
        general_branch_id: "",
        company_type: "",
        exporter_house: "",
        payment_method: "",
        exporter_type: ""
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({}),
        onSubmit: (values, { resetForm }) => {
            values.customer_id = atob(b64id);
            if (branch_id) {
                values.general_branch_id = Number(branch_id)
            }
            setDisableSubmit(true);
            try {
                const config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }

                let url = `${adminMainUrl}/api/organization/general/branch/custom_detail/add-update`;

                // if (branch_id == 0) {
                //     url = `${adminMainUrl}/api/organization/general/branch/add`;
                // } else {
                //     url = `${adminMainUrl}/api/organization/general/branch/update`;
                //     values.id = Number(branch_id);
                // }

                axios.post(url, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            setDisableSubmit(false);
                            refresh();
                            resetForm();
                        } else {
                            toast.error(response.data.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal server error."
                        if (error.response) {
                            if (error.response.data) {
                                if (error.response.data.msg) {
                                    msg = error.response.data.msg
                                }
                            }
                        }
                        toast.error(msg);
                        setDisableSubmit(false);
                    });
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });



    // branch id based selection
    // if 0 -> reset form to add new entries.
    // if !=0 -> use dispatch to set details to edit form

    useEffect(() => {
        if (branch_id == 0) {
            formik.resetForm();
        } else {
            if (token && user_id && branch_id && b64id) {
                let id = atob(b64id);
                if (id) {
                    dispatch(getBranchCustomDetail(token, user_id, branch_id, id));
                }
            }
        }
    }, [branch_id]);

    const refresh = () => {
        if (branch_id == 0) {
            formik.resetForm();
        } else {
            if (token && user_id && branch_id && b64id) {
                let id = atob(b64id);
                if (id) {
                    dispatch(getBranchCustomDetail(token, user_id, branch_id, id));
                }
            }
        }
    }



    useEffect(() => {

        if (loadingBranchCustomDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (branch_id) {
            if (BranchCustomDetail) {
                formik.setFieldValue("company_type", BranchCustomDetail?.company_type);
                formik.setFieldValue("exporter_house", BranchCustomDetail?.exporter_house);
                formik.setFieldValue("payment_method", BranchCustomDetail?.payment_method);
                formik.setFieldValue("exporter_type", BranchCustomDetail?.exporter_type);
            }
        } else {
            formik.setFieldValue("company_type", "");
            formik.setFieldValue("exporter_house", "");
            formik.setFieldValue("payment_method", "");
            formik.setFieldValue("exporter_type", "");
        }

    }, [branch_id, loadingBranchCustomDetail, BranchCustomDetailError, BranchCustomDetail]);

    const customStyles = {
        control: (base) => ({
          ...base,
          height: 29,
          minHeight: 29,
          display: 'flex',
          alignItems: 'center',
        }),
        placeholder: (base) => ({
          ...base,
          display: 'flex',
          alignItems: 'center',
          fontSize: '12px',
          fontWeight: "600",
          color: '#808080',
        }),
        menu: (base) => ({
          ...base,
          fontSize: '12px',
        }),
        option: (base) => ({
          ...base,
          fontSize: '12px',
        }),
        singleValue: (base) => ({
          ...base,
          fontSize: '12px',
          display: 'flex', // Ensure singleValue aligns center vertically
          alignItems: 'center',
        }),
      };




    return (
        <>
            {
                showLoader ?
                    <Beatloader /> :
                    <>
                        <h2 className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark accordion-header">
                            <button type="button" aria-expanded="true" className="accordion-button">
                                {" "}
                                <span className="avatar avatar-md rounded text-dark border me-2">
                                    <i className="ti ti-user-plus fs-20" />
                                </span>
                                Edit Custom Details
                            </button>
                        </h2>
                        <form onSubmit={formik.handleSubmit}>
                            <div className="row">
                                {/* Hidden for now */}
                                {/* <div className="col-md-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="branch_name" className="form-label mb-0 ">
                                                Branch Sr. No.
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            id="name"
                                            name="branch_sr_no"
                                            placeholder='Enter Branch Sr No'
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.branch_sr_no}
                                        />
                                    </div>
                                </div> */}
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="company_type" className="form-label mb-0 ">
                                                Company Type
                                            </label>
                                        </div>
                                        <div className="mb-1">
                                            <select
                                                className="form-control form-control-sm"
                                                id="company_type"
                                                name="company_type"
                                                placeholder='Enter Address'
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.company_type}
                                            >
                                                <option>-Select an option-</option>
                                                <option value="Private">Private</option>
                                                <option value="Government Departments">Government Departments</option>
                                                <option value="Government Undertakings">Government Undertakings</option>
                                                <option value="Diplomatic/UN-its org">Diplomatic/UN-its org</option>
                                                <option value="Public Sector">Public Sector</option>

                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="exporter_house" className="form-label mb-0 ">
                                                Exporter House
                                            </label>
                                        </div>
                                        <div className="mb-1">
                                            <select
                                                className="form-control form-control-sm"
                                                id="exporter_house"
                                                name="exporter_house"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.exporter_house}
                                            >
                                                <option>N/A</option>
                                                <option value="Export House">Export House</option>
                                                <option value="Star Trading House">Star Trading House</option>
                                                <option value="Super Star Trading House">Super Star Trading House</option>
                                                <option value="Trading House">Trading House</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="payment_method" className="form-label mb-0 ">
                                                Payment Method
                                            </label>
                                        </div>
                                        <div className="mb-1">
                                            <select
                                                className="form-control form-control-sm"
                                                id="payment_method"
                                                name="payment_method"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.payment_method}
                                            >
                                                <option>-Select an Option-</option>
                                                <option value="Transaction">Transaction</option>
                                                <option value="Deferred">Deferred</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                            <label htmlFor="exporter_type" className="form-label mb-0 ">
                                                Expoter Type
                                            </label>
                                        </div>
                                        <div className="mb-1">
                                            <select
                                                className="form-control form-control-sm"
                                                id="exporter_type"
                                                name="exporter_type"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.exporter_type}
                                            >
                                                <option>-Select an Option-</option>
                                                <option value="Manufacturer Exporter">Manufacturer Exporter</option>
                                                <option value="Merchant Exporter">Merchant Exporter</option>
                                                <option value="Others">Others</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex flex-wrap gap-2">
                                </div>
                                <button className="btn btn-sm btn-danger" type='submit' disabled={disableSubmit} >
                                    {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : `Update`}
                                </button>
                            </div>
                        </form>
                        <div className="col-md-12">
                            <div className="row-gap-2">
                                <Tabs
                                    activeKey={activeTab} // Controlled by state
                                    onSelect={(k) => setActiveTab(k)} // Update state on tab change
                                    transition={false}
                                    id="noanim-tab-example"
                                    className="nav nav-pills mb-3 custom-tabs gap-0"
                                >
                                    <Tab eventKey="bankdealer" title="Bank/Dealer" className="nav-item">
                                        <BankDealerList branch_id={branch_id} token={token} user_id={user_id} b64id={b64id} />
                                    </Tab>
                                    {/* <Tab eventKey="drawbackdetail" title="Drawback Detail" className="nav-item" disabled={branch_id ? false : true}>
                                        <MoreAddresses branch_id={branch_id} branch_country_id={branch_country_id} token={token} user_id={user_id} b64id={b64id} refresh={refresh} />
                                    </Tab> */}
                                </Tabs>
                            </div>
                        </div>
                    </>
            }
        </>
    )
}

export default CustomDetails